import React, { useEffect, useState } from 'react'
import './Feed.css';
import CreateIcon from '@mui/icons-material/Create';
import InputOption from './InputOption';
import ImageIcon from '@mui/icons-material/Image';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import Post from './Post';
import { db } from './firebase.js';
import firebase from 'firebase/compat/app';
import { useSelector } from 'react-redux';
import { selectUser } from './features/userSlice';
import FlipMove from 'react-flip-move';

function Feed() {
    const user = useSelector(selectUser);
    const [inputText, setInputText] = useState('');
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        db.collection("posts").orderBy('timestamp', 'desc')
        .onSnapshot(snapshot => {
            setPosts(snapshot.docs.map((doc) => (
                {
                    id: doc.id,
                    data: doc.data(),
                }
            )));
        });
    }, []);

    const sendPost = (e) => {
        e.preventDefault();
        db.collection("posts").add({
            name: user.displayName,
            description: user.email,
            message: inputText,
            photoUrl: user.photoUrl || '',
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        });

        setInputText('');
    };

  return (
    <div className='feed'>
        <div className='feed_inputContainer'>
            <div className='feed_input'>
                <CreateIcon />
                <form>
                    <input value={inputText} onChange={(e) => {
                        setInputText(e.target.value)}} type='text' />
                    <button onClick={sendPost} type='submit'>Send</button>
                </form>
            </div>
            <div className='feed_inputOptions'>
                <InputOption Icon={ImageIcon} title='Photo' color='#70b5f9' />
                <InputOption Icon={SubscriptionsIcon} title='Video' 
                color='#e7a33e' />
                <InputOption Icon={EventNoteIcon} title='Event' 
                color='#c0cbcd' />
                <InputOption Icon={CalendarViewDayIcon} title='Write article' 
                color='#75c15e' />
            </div>
        </div>

        {/* Posts */}
        <FlipMove>
        {posts.map(({ id, data: { name, message, description, photoUrl }}) => (
            <Post 
            key={id}
            name={name}
            message={message}
            description={description}
            photoUrl={photoUrl}/>
        ))}
        </FlipMove>
        
    </div>
  )
}

export default Feed